<template>
  <section>
    <top-menu/>

    <section>
      <page-header :headerName="pageTitle" :showBtn="false" :btnName="''" :btnRoute="''" :css="'container'"/>

      <div class="page-content">
        <div class="container">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box filters">

                <!-- Passos -->
                <div class="bc-steps">
                  <span class="bc-step" :class="{ 'is-active': step === 1, 'is-done': step > 1 }">
                    <i>{{ step > 1 ? '✓' : '1' }}</i> {{ isEdit ? 'Editar aviso' : 'Criar aviso' }}
                  </span>
                  <span class="bc-step__line"></span>
                  <span class="bc-step" :class="{ 'is-active': step === 2 }">
                    <i>2</i> Configurar envio
                  </span>
                </div>

                <p class="bc-hint bc-hint--error" v-if="loadError">{{ loadError }}</p>

                <!-- ============ PASSO 1 ============ -->
                <div v-if="step === 1" class="col-xs-12 col-sm-12 col-md-12">
                  <h4 class="bc-section">Detalhes do aviso</h4>
                  <placeholder-chips @insert="insertPlaceholder"/>

                  <!-- Linha 1: tipo, titulo e subtitulo lado a lado. -->
                  <div class="bc-row">
                    <div class="col-xs-12 col-sm-12 col-md-4">
                      <div class="form-group">
                        <label>Tipo</label>
                        <select v-model.number="form.type" class="form-control">
                          <option v-for="opt in typeOptions" :key="opt.value" :value="opt.value">
                            {{ opt.label }}
                          </option>
                        </select>
                        <p class="bc-hint">{{ typeHint }}</p>
                      </div>
                    </div>

                    <div class="col-xs-12 col-sm-12 col-md-4">
                      <div class="form-group">
                        <label>Título do aviso</label>
                        <input ref="titleInput" v-model="form.title" type="text" class="form-control"
                               :maxlength="limits.title" placeholder="Título do aviso"
                               @focus="lastField = 'title'" @blur="remember('title', $event)">
                        <p class="bc-hint bc-hint--error" v-if="step1Errors.title">{{ step1Errors.title }}</p>
                      </div>
                    </div>

                    <div class="col-xs-12 col-sm-12 col-md-4">
                      <div class="form-group">
                        <label>Subtítulo <small>(uma linha)</small></label>
                        <input ref="subtitleInput" v-model="form.subtitle" type="text" class="form-control"
                               :maxlength="limits.subtitle" @focus="lastField = 'subtitle'"
                               @blur="remember('subtitle', $event)">
                        <p class="bc-hint">Aparece abaixo do título. No app do colaborador é o único texto.</p>
                      </div>
                    </div>
                  </div>

                  <!-- Linha 2: imagem (so banner), rotulo do botao e link de destino.
                       Sem a imagem, os dois campos dividem a linha ao meio. -->
                  <div class="bc-row">
                    <!-- Imagem so no banner: os modais nao desenham ilustracao. O
                         botao envia o arquivo para o storage (api-v1 blog/uploadImage,
                         o mesmo do blog) e devolve a URL publica para o campo. -->
                    <div class="col-xs-12 col-sm-12 col-md-4" v-if="isBanner">
                      <div class="form-group">
                        <label>Imagem <small>(recomendado 407×151 px)</small></label>
                        <div class="bc-image-field">
                          <input v-model="form.imageUrl" type="text" class="form-control"
                                 :maxlength="limits.url" placeholder="https://..."
                                 :disabled="uploadingImage">
                          <button type="button" class="btn default bc-image-field__upload"
                                  :disabled="uploadingImage"
                                  v-tooltip.top-center="{ content: 'Enviar imagem do computador', classes: 'bc-tooltip' }"
                                  v-on:click="pickImage">
                            <ion-icon name="cloud-upload-outline"></ion-icon>
                            <span>{{ uploadingImage ? 'Enviando…' : 'Enviar' }}</span>
                          </button>
                          <span class="bc-image-field__remove" role="button" tabindex="0"
                                v-if="form.imageUrl && !uploadingImage"
                                v-tooltip.top-center="{ content: 'Remover imagem', classes: 'bc-tooltip' }"
                                v-on:click="removeImage" v-on:keydown.enter.prevent="removeImage">
                            <ion-icon name="trash-outline"></ion-icon>
                            <span>Remover</span>
                          </span>
                          <input ref="imageFile" type="file" class="bc-image-field__file"
                                 accept="image/png,image/jpeg,image/svg+xml,image/webp"
                                 v-on:change="onImageSelected">
                        </div>
                        <p class="bc-hint">PNG, JPG, SVG ou WebP. Depois de escolher, você enquadra a imagem no formato do banner; SVG entra sem recorte.</p>
                        <p class="bc-hint bc-hint--error" v-if="imageError">{{ imageError }}</p>
                      </div>
                    </div>

                    <div class="col-xs-12 col-sm-12" :class="isBanner ? 'col-md-4' : 'col-md-6'">
                      <div class="form-group">
                        <label>Rótulo do botão</label>
                        <input v-model="form.ctaLabel" type="text" class="form-control"
                               :maxlength="limits.ctaLabel" :placeholder="isBanner ? 'Ver detalhes' : 'Entendi'">
                        <p class="bc-hint">{{ isBanner ? 'Leva ao link de destino.' : 'Fecha o aviso.' }}</p>
                      </div>
                    </div>

                    <!-- Link so existe no banner: a nota de versao nao redireciona, o
                         botao dela so fecha. Um campo desabilitado com "fica ignorado"
                         deixava o operador em duvida se o link ia ou nao. -->
                    <div class="col-xs-12 col-sm-12 col-md-4" v-if="isBanner">
                      <div class="form-group">
                        <label>Link de destino</label>
                        <input v-model="form.ctaUrl" type="text" class="form-control"
                               :maxlength="limits.url"
                               placeholder="/relatórios ou https://...">
                        <p class="bc-hint bc-hint--error" v-if="step1Errors.ctaUrl">{{ step1Errors.ctaUrl }}</p>
                        <p class="bc-hint" v-else>
                          Para onde o usuário vai ao clicar no banner. Caminho interno
                          (ex.: /timesheet) ou endereço https://.
                        </p>
                      </div>
                    </div>
                  </div>

                  <!-- Cor so existe no banner: a faixa e o unico lugar que usa. -->
                  <div class="col-xs-12 col-sm-12 col-md-12" v-if="isBanner">
                    <div class="form-group">
                      <label>Cor da faixa</label>
                      <div class="bc-swatches">
                        <button v-for="sw in swatches" :key="sw.value" type="button"
                                class="bc-swatch" :class="{ 'is-active': form.color === sw.value }"
                                :style="{ background: sw.hex }" :title="sw.label"
                                v-on:click="form.color = sw.value"></button>
                      </div>
                    </div>
                  </div>

                  <!-- Banner vive de titulo + subtitulo: nenhum cliente desenha o
                       corpo nele, entao o editor so aparece para os modais. -->
                  <div class="col-xs-12 col-sm-12 col-md-12" v-if="!isBanner">
                    <div class="form-group">
                      <label>Texto</label>
                      <broadcast-editor ref="body" v-model="form.body" @focus="lastField = 'body'"/>
                      <p class="bc-hint bc-hint--error" v-if="step1Errors.body">{{ step1Errors.body }}</p>
                    </div>
                  </div>

                  <h4 class="bc-section">Comportamento</h4>

                  <div class="col-xs-12 col-sm-12 col-md-12">
                    <div class="checkbox inline-block">
                      <input v-model="form.dismissible" id="dismissible" type="checkbox">
                      <label v-on:click="form.dismissible = !form.dismissible">
                        Pode ser dispensado pelo usuário
                      </label>
                      <!-- Fora do <label> de proposito: dentro dele, passar o mouse
                           para ler a explicacao acabaria alternando o checkbox. -->
                      <i class="fa fa-question-circle bc-help" aria-hidden="true"
                         v-tooltip.top-center="{ content: dismissibleHint, classes: 'bc-tooltip' }"></i>
                    </div>

                  </div>

                  <div class="col-xs-12 col-sm-12 col-md-12">
                    <label class="bc-field-label">Quem vê</label>
                    <div class="bc-surfaces">
                      <div class="checkbox inline-block" v-for="opt in audienceOptions" :key="'aud-' + opt.value">
                        <input type="checkbox" :id="'audience-' + opt.value" :value="opt.value" v-model="form.audience">
                        <label v-on:click="toggleAudience(opt.value)">{{ opt.label }}</label>
                      </div>
                    </div>
                    <p class="bc-hint">Gestor de equipe é o colaborador responsável por pelo menos uma equipe. Administrador secundário conta como administrador.</p>
                    <p class="bc-hint bc-hint--error" v-if="step1Errors.audience">{{ step1Errors.audience }}</p>
                  </div>

                  <div class="col-xs-12 col-sm-12 col-md-12">
                    <label class="bc-field-label">Onde aparece</label>
                    <div class="bc-surfaces">
                      <div class="checkbox inline-block" v-for="opt in surfaceOptions" :key="opt.value">
                        <input type="checkbox" :id="'surface-' + opt.value" :value="opt.value" v-model="form.surfaces">
                        <label :title="opt.hint" v-on:click="toggleSurface(opt.value)">{{ opt.label }}</label>
                      </div>
                    </div>
                    <p class="bc-hint">Backoffice cobre o V2 e o legado; qual dos dois a empresa vê é configuração dela.</p>
                    <p class="bc-hint bc-hint--error" v-if="step1Errors.surfaces">{{ step1Errors.surfaces }}</p>
                  </div>

                  <h4 class="bc-section">Visualização</h4>
                  <div class="col-xs-12 col-sm-12 col-md-12">
                    <broadcast-preview :form="form"/>
                  </div>

                  <div class="col-xs-12 col-sm-12 col-md-12 bc-actions">
                    <button type="button" class="btn default" v-on:click="$router.push('/avisos-e-campanhas')">
                      Voltar
                    </button>
                    <button type="button" class="btn blue" :disabled="hasStep1Errors"
                            v-on:click="step = 2">
                      Próximo passo
                    </button>
                  </div>
                </div>

                <!-- ============ PASSO 2 ============ -->
                <broadcast-audience
                  v-else
                  :form="form"
                  :broadcast-id="broadcastId"
                  :initial-companies="initialCompanies"
                  v-on:back="step = 1"
                  v-on:sent="onSent"
                />

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <full-loading v-if="loading"/>
    <modal-crop-banner v-if="cropFile" :file="cropFile" @done="onCropped" @cancel="cropFile = null"/>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import broadcastEditor from "./broadcastEditor.vue";
import broadcastPreview from "./broadcastPreview.vue";
import broadcastAudience from "./broadcastAudience.vue";
import placeholderChips from "./placeholderChips.vue";
import modalCropBanner from "./modalCropBanner.vue";
import swal from 'sweetalert';
import { lockedReason } from "./broadcastStatus";
import { REQUEST_SERVICE } from "../../../../requestConfig";

import { shouldCrop } from "./bannerCrop";
import { insertPlaceholderAt, resolveInsertTarget } from "./broadcastPlaceholders";
import { isNoCrossToken, requestApiV2 } from "./broadcastApiV2Auth";
import { BROADCAST_BY_ID, UPLOAD_IMG_BLOG } from "../../../../urlConfig";
import {
  BROADCAST_AUDIENCE_DEFAULT,
  BROADCAST_AUDIENCE_OPTIONS,
  BROADCAST_BODY_MAX,
  BROADCAST_COLOR,
  BROADCAST_COLOR_SWATCHES,
  BROADCAST_CTA_LABEL_MAX,
  BROADCAST_IMAGE_MAX_BYTES,
  BROADCAST_SUBTITLE_MAX,
  BROADCAST_SURFACE_OPTIONS,
  BROADCAST_TITLE_MAX,
  BROADCAST_TYPE,
  BROADCAST_TYPE_OPTIONS,
  BROADCAST_URL_MAX,
  isBroadcastBannerType,
  isValidBroadcastUrl,
  maskToAudience,
  maskToSurfaces,
} from "./broadcastEnums";

/**
 * `<input type="date">` so aceita `yyyy-MM-dd`; a API devolve um
 * `DateTimeOffset` ISO. Cortar os 10 primeiros caracteres preserva a data tal
 * como foi gravada — converter para `Date` primeiro a deslocaria um dia nos
 * fusos a oeste de UTC.
 */
function toDateInput(value) {
  const text = value ? String(value) : '';
  return /^\d{4}-\d{2}-\d{2}/.test(text) ? text.slice(0, 10) : '';
}

export default {
  name: "broadcast-create",
  components: {
    topMenu,
    pageHeader,
    fullLoading,
    broadcastEditor,
    broadcastPreview,
    broadcastAudience,
    placeholderChips,
    modalCropBanner,
  },
  data() {
    return {
      step: 1,
      lastField: 'title',
      lastCaret: null,
      loading: false,
      loadError: '',
      // Empresas ja direcionadas, carregadas na edicao e entregues ao passo 2.
      initialCompanies: [],
      uploadingImage: false,
      imageError: '',
      // Arquivo em recorte no momento; a modal so aparece quando existe.
      cropFile: null,
      dismissibleHint:
        'Depois de dispensar, o modal ou o banner não aparece mais para aquele usuário.',
      typeOptions: BROADCAST_TYPE_OPTIONS,
      swatches: BROADCAST_COLOR_SWATCHES,
      surfaceOptions: BROADCAST_SURFACE_OPTIONS,
      audienceOptions: BROADCAST_AUDIENCE_OPTIONS,
      limits: {
        title: BROADCAST_TITLE_MAX,
        subtitle: BROADCAST_SUBTITLE_MAX,
        body: BROADCAST_BODY_MAX,
        ctaLabel: BROADCAST_CTA_LABEL_MAX,
        url: BROADCAST_URL_MAX,
      },
      form: {
        type: BROADCAST_TYPE.RELEASE_NOTE,
        title: '',
        subtitle: '',
        body: '',
        imageUrl: '',
        color: BROADCAST_COLOR.PRIMARY,
        ctaLabel: '',
        ctaUrl: '',
        dismissible: true,
        audience: BROADCAST_AUDIENCE_DEFAULT.slice(),
        // Bits de BROADCAST_SURFACE marcados. Comeca com todos: e o que o
        // fluxo fazia antes de existir a escolha.
        surfaces: BROADCAST_SURFACE_OPTIONS.map((opt) => opt.value),
        startsAt: '',
        endsAt: '',
        // Quando true a audiencia e resolvida no SERVIDOR no envio; a selecao
        // manual fica desativada e a lista de empresas vai vazia.
        targetAllActive: false,
        companies: [],
      },
    };
  },
  computed: {
    /** Id na rota `/avisos-e-campanhas/:id/editar`; vazio na criacao. */
    broadcastId() {
      return this.$route.params.id || '';
    },
    isEdit() {
      return !!this.broadcastId;
    },
    pageTitle() {
      return this.isEdit ? 'Editar Aviso' : 'Visualizar e Enviar Avisos';
    },
    isBanner() {
      return isBroadcastBannerType(this.form.type);
    },
    typeHint() {
      const found = this.typeOptions.find((o) => o.value === this.form.type);
      return found ? found.hint : '';
    },
    urlIsValid() {
      return isValidBroadcastUrl(this.form.ctaUrl);
    },
    /**
     * Trava o passo 1 em vez de deixar a API recusar depois: o autor descobre o
     * problema com o texto na frente, nao no fim do fluxo de envio.
     *
     * Um erro POR CAMPO, e nao uma lista no rodape: a mensagem sai embaixo do
     * campo que a causou, entao nao sobra o trabalho de descobrir a qual campo
     * cada linha se referia.
     */
    step1Errors() {
      const errors = { title: '', body: '', ctaUrl: '', surfaces: '', audience: '' };

      if (!this.form.title.trim()) {
        errors.title = 'Informe o título do aviso.';
      }

      if ((this.form.body || '').length > this.limits.body) {
        errors.body = 'O texto passou de ' + this.limits.body + ' caracteres.';
      } else if (!this.isBanner && !(this.form.body || '').trim()) {
        // Modal sem corpo nao mostra nada; banner vive de titulo + subtitulo.
        errors.body = 'Modais precisam de texto.';
      }

      if (this.form.ctaUrl && !this.urlIsValid) {
        errors.ctaUrl = 'O link de destino não é válido.';
      } else if (this.isBanner && !this.form.ctaUrl) {
        // O banner e clicavel por inteiro: sem destino ele vira so um bloco de texto.
        errors.ctaUrl = 'Banner precisa de um link de destino.';
      }

      // Sem superficie a campanha e gravada e nao aparece em lugar nenhum.
      if (!this.form.surfaces.length) {
        errors.surfaces = 'Marque pelo menos um lugar onde o aviso aparece.';
      }

      // Sem publico a campanha e gravada e ninguem a ve; a API tambem recusa.
      if (!this.form.audience.length) {
        errors.audience = 'Marque pelo menos um público.';
      }

      return errors;
    },
    hasStep1Errors() {
      const errors = this.step1Errors;
      return Object.keys(errors).some((field) => !!errors[field]);
    },
  },
  created() {
    if (this.isEdit) {
      this.loadBroadcast();
    }
  },
  watch: {
    /**
     * Nota de versao nao redireciona. Limpar o destino ao trocar de tipo evita
     * salvar um `ctaUrl` que nenhuma tela vai usar — e que reapareceria se o
     * tipo mudasse de novo.
     */
    'form.type': function (value) {
      if (value === BROADCAST_TYPE.RELEASE_NOTE) {
        this.form.ctaUrl = '';
      }
    },
  },
  methods: {
    remember(field, event) {
      this.lastField = field;
      this.lastCaret = event.target.selectionStart;
    },
    /** Clique no chip: vai para o campo com foco AGORA, ou o ultimo com cursor conhecido. */
    insertPlaceholder(token) {
      if (this.lastField === 'body' && this.$refs.body) {
        this.$refs.body.insertAtCursor(token);
        return;
      }
      const active = document.activeElement;
      let activeFieldName = null;
      if (active === this.$refs.titleInput) activeFieldName = 'title';
      else if (active === this.$refs.subtitleInput) activeFieldName = 'subtitle';
      const activeCaret = activeFieldName ? active.selectionStart : null;

      const { field, caret } = resolveInsertTarget(this.lastField, activeFieldName, activeCaret, this.lastCaret);
      const target = field === 'subtitle' ? 'subtitle' : 'title';
      const next = insertPlaceholderAt(this.form[target], caret, token);
      this.form[target] = next.text;
      this.lastField = target;
      this.lastCaret = next.caret;

      const refName = target === 'subtitle' ? 'subtitleInput' : 'titleInput';
      this.$nextTick(() => {
        const input = this.$refs[refName];
        if (input) {
          input.focus();
          input.setSelectionRange(next.caret, next.caret);
        }
      });
    },
    pickImage() {
      this.imageError = '';
      if (this.$refs.imageFile) this.$refs.imageFile.click();
    },
    /** Imagem e opcional: sem ela o banner vive de titulo + subtitulo. */
    removeImage() {
      this.form.imageUrl = '';
      this.imageError = '';
    },
    /**
     * Valida no front antes de subir: tipo e tamanho. O storage aceita mais que
     * isto, mas uma imagem de 8 MB num banner que carrega em toda dashboard e
     * custo para o cliente, nao para o Master.
     */
    onImageSelected(event) {
      const file = event.target.files && event.target.files[0];
      event.target.value = '';
      if (!file) return;

      const allowed = ['image/png', 'image/jpeg', 'image/svg+xml', 'image/webp'];
      if (allowed.indexOf(file.type) === -1) {
        this.imageError = 'Formato não aceito. Use PNG, JPG, SVG ou WebP.';
        return;
      }

      this.imageError = '';

      if (shouldCrop(file)) {
        // Bitmap passa pelo recorte; o arquivo recortado e que sobe.
        this.cropFile = file;
        return;
      }
      this.uploadImage(file);
    },
    onCropped(file) {
      this.cropFile = null;
      this.uploadImage(file);
    },
    /**
     * Valida o tamanho no arquivo que realmente sobe: para bitmap, isso e o
     * recorte ja exportado, nao o arquivo original que o usuario escolheu.
     */
    uploadImage(file) {
      if (file.size > BROADCAST_IMAGE_MAX_BYTES) {
        this.imageError = 'A imagem passou de 2 MB.';
        return;
      }

      this.uploadingImage = true;
      this.imageError = '';

      REQUEST_SERVICE.fileUploadV2(UPLOAD_IMG_BLOG, file)
        .then((response) => {
          // O endpoint responde a URL publica como string JSON.
          const url = response && typeof response.data === 'string' ? response.data.trim() : '';
          if (!url) {
            this.imageError = 'O envio não devolveu a URL da imagem.';
            return;
          }
          this.form.imageUrl = url;
        })
        .catch(() => {
          this.imageError = 'Não foi possível enviar a imagem. Tente novamente.';
        })
        .then(() => {
          this.uploadingImage = false;
        });
    },
    /**
     * A API NAO publica `GET v1/mamlabs/broadcasts/{id}`: a listagem e a unica
     * leitura que devolve o conteudo inteiro da campanha, entao a edicao acha a
     * linha nela. A audiencia vem separada, do engajamento, que e onde as
     * empresas direcionadas aparecem uma a uma.
     */
    loadBroadcast() {
      this.loading = true;
      this.loadError = '';

      // GET {id} devolve o item da listagem MAIS a audiencia direcionada com
      // nome, CNPJ e codigo — a mesma tabela que o passo 2 mostra ao criar.
      requestApiV2('GET', BROADCAST_BY_ID(this.broadcastId))
        .then((response) => {
          const data = (response && response.data) || {};

          if (!data.item) {
            this.loadError = 'Aviso não encontrado.';
            return;
          }

          // A listagem nao mostra o lapis para aviso cancelado ou encerrado;
          // quem chega aqui pela URL volta para ela com o motivo.
          const locked = lockedReason(data.item);
          if (locked) {
            swal("Aviso", locked, "warning");
            this.$router.push('/avisos-e-campanhas');
            return;
          }

          this.fill(data.item);

          // Banco sem resposta significa audiencia incompleta na tela; salvar
          // assim apagaria as empresas que faltaram da selecao.
          if ((data.shardsFailed || []).length) {
            this.loadError =
              'Audiência incompleta: ' +
              data.shardsFailed.join(', ') +
              ' não responderam. Confira as empresas antes de salvar.';
          }

          this.initialCompanies = (data.companies || []).map((row) => ({
            companyId: row.companyId,
            contextCode: row.contextCode,
            name: row.name,
            cnpj: row.cnpj || '',
            code: row.code || '',
          }));
        })
        .catch((error) => {
          const status = error && error.response && error.response.status;
          if (isNoCrossToken(error)) {
            this.loadError = 'Saia e entre novamente no Master para autenticar na API v2.';
          } else if (status === 404) {
            this.loadError = 'Aviso não encontrado.';
          } else {
            this.loadError = 'Não foi possível carregar o aviso.';
          }
        })
        .then(() => {
          this.loading = false;
        });
    },
    fill(item) {
      this.form.type = item.type;
      this.form.title = item.title || '';
      this.form.subtitle = item.subtitle || '';
      this.form.body = item.body || '';
      this.form.imageUrl = item.imageUrl || '';
      this.form.color = item.color || BROADCAST_COLOR.PRIMARY;
      this.form.ctaLabel = item.ctaLabel || '';
      this.form.ctaUrl = item.ctaUrl || '';
      this.form.dismissible = !!item.dismissible;
      this.form.audience = maskToAudience(item.audience);
      this.form.surfaces = maskToSurfaces(item.surfaces);
      this.form.startsAt = toDateInput(item.startsAt);
      this.form.endsAt = toDateInput(item.endsAt);
      this.form.targetAllActive = !!item.targetAllActive;
    },
    toggleSurface(bit) {
      const index = this.form.surfaces.indexOf(bit);
      if (index === -1) {
        this.form.surfaces.push(bit);
      } else {
        this.form.surfaces.splice(index, 1);
      }
    },
    toggleAudience(bit) {
      const index = this.form.audience.indexOf(bit);
      if (index === -1) {
        this.form.audience.push(bit);
      } else {
        this.form.audience.splice(index, 1);
      }
    },
    onSent(result) {
      const total = (result && result.targeted) || 0;
      if (this.isEdit) {
        swal('Salvo', 'Aviso atualizado para ' + total + ' empresa(s).', 'success');
      } else {
        swal('Enviado', 'Aviso publicado para ' + total + ' empresa(s).', 'success');
      }
      this.$router.push('/avisos-e-campanhas');
    },
  },
};
</script>

<style scoped>
.bc-steps {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 18px 0 6px;
  width: 100%;
}

.bc-step { display: flex; align-items: center; gap: 8px; font-size: 13px; color: #9ca0a7; }
.bc-step i {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #d5d7da;
  color: #fff;
  font-style: normal;
  font-size: 12px;
}
.bc-step.is-active { color: #3a424e; font-weight: 600; }
.bc-step.is-active i { background: #1b59f8; }
.bc-step.is-done i { background: #1b59f8; }
.bc-step__line { width: 160px; height: 1px; background: #d5d7da; }

.bc-section {
  width: 100%;
  clear: both;
  margin: 0 0 6px;
  padding-top: 16px;
  padding-bottom: 6px;
  border-bottom: 1px solid #eceff3;
  font-size: 16px;
  font-weight: 700;
  color: #3a424e;
}

/* Rotulos dos campos do passo 1 ("Tipo", "Titulo", "Onde aparece"...), todos
   iguais entre si e abaixo do titulo de secao. O <small> dentro do rotulo
   (observacao) volta ao peso normal. */
.form-group > label,
.bc-field-label {
  font-size: 13px;
  font-weight: 600;
  color: #3a424e;
}

.form-group > label small {
  font-weight: 400;
}

.bc-help {
  margin-left: 6px;
  color: #9ca0a7;
  cursor: help;
}

.bc-hint { margin: 4px 0 0; font-size: 12px; color: #9ca0a7; }
.bc-hint--error { color: #ff445d; }

/* Mesmo layout da linha de cima (Pode ser dispensado / Somente admins): bloco
   com .checkbox.inline-block e o margin-left global de 30px, para as caixas
   alinharem com as de cima. Sem flex: o flex tirava o margin e o pseudo
   elemento do checkbox (::before, 20px absoluto) cobria o texto. */
.bc-surfaces {
  margin-top: 4px;
}

.bc-surfaces .checkbox {
  float: none;
  margin-right: 12px;
}

/* Linha de campos: flex em vez de float, para colunas de alturas diferentes
   (dica, erro) nao empurrarem a proxima linha. */
.bc-row { display: flex; flex-wrap: wrap; width: 100%; clear: both; }
.bc-row > [class*="col-"] { float: none; }

.bc-image-field { display: flex; gap: 8px; align-items: stretch; }
.bc-image-field .form-control { flex: 1 1 auto; min-width: 0; }
/* O global `.filters button` empurra todo botao 4px para baixo (top: 4px),
   da margin-left de 17px e largura fixa de 120px. Aqui o botao e um item do
   flex ao lado do input: zera esses deslocamentos e estica na MESMA altura do
   input (align-items: stretch + height auto), em vez de chutar um numero. */
.bc-image-field__upload {
  flex: 0 0 auto;
  align-self: stretch;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  position: static;
  top: 0;
  width: auto;
  height: auto;
  margin: 0;
  padding: 0 12px;
  line-height: 1;
}
.bc-image-field__upload ion-icon { font-size: 18px; }
.bc-image-field__remove {
  flex: 0 0 auto;
  align-self: stretch;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0 10px;
  color: #e74a4e;
  cursor: pointer;
}
.bc-image-field__remove ion-icon { font-size: 18px; }
.bc-image-field__file { display: none; }

.bc-swatches { display: flex; gap: 8px; }
.bc-swatch {
  width: 26px;
  height: 26px;
  border: 2px solid transparent;
  border-radius: 50%;
  cursor: pointer;
}
.bc-swatch.is-active { border-color: #3a424e; }

.bc-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 18px 0 6px;
}
</style>

<style>
/* v-tooltip monta o balao no body, fora do scoped. O bootstrap global define
   .tooltip { opacity: 0 } (espera a classe .in do proprio bootstrap), o que
   deixava o balao invisivel — por isso a classe propria e o !important. */
.tooltip.bc-tooltip {
  display: block;
  z-index: 10000;
  opacity: 1 !important;
}
.tooltip.bc-tooltip .tooltip-inner {
  max-width: 260px;
  padding: 8px 10px;
  background: #3a424e;
  color: #fff;
  border-radius: 6px;
  font-size: 12px;
  line-height: 1.4;
  text-align: left;
}
.tooltip.bc-tooltip .tooltip-arrow {
  display: none;
}
.tooltip.bc-tooltip[aria-hidden="true"] {
  visibility: hidden;
  opacity: 0 !important;
}
.tooltip.bc-tooltip[aria-hidden="false"] {
  visibility: visible;
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/broadcast/broadcastCreate.vue